
import AddJobRoleForm from "../../components/Forms/AddJobRoleForm";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";






function AddJobRole() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <AddJobRoleForm/>
               
            </BasicCard>
        </>
    )
}
export default AddJobRole;